import { useMutation } from '@tanstack/react-query';
import { TranscribeAudioResponse, transcribeAudioContract } from '@bliks-io/contracts';
import { audioBlobFilename } from '@bliks-io/ui';
import { apiClient } from '../client';

/**
 * Transcribe audio mutation
 *
 * Sends a recorded audio blob to the backend for transcription.
 * Returns the transcribed text.
 *
 * Failures are not toasted here: the voice-input slot maps every failure kind
 * — a denied microphone, a broken recording, this call — to one message, so a
 * toast here would be the second one for the same failure.
 */
export function useTranscribeAudio() {
  return useMutation({
    mutationFn: async (audioBlob: Blob): Promise<TranscribeAudioResponse> => {
      const formData = new FormData();
      formData.append('audio', audioBlob, audioBlobFilename(audioBlob));

      const { data } = await apiClient.post<TranscribeAudioResponse>(
        transcribeAudioContract.path,
        formData,
        { timeout: 60_000 }
      );
      return data;
    }
  });
}
